export const DASHBOARD_INTENTS = Object.freeze({
  DASHBOARD: "/dashboard",
  DONATION: "/dashboard/donations",
  INIT: "/dashboard/init",
  ORDER: "/dashboard/orders",
  ORDER_DETAIL: "/dashboard/order/view",
  PRODUCT: "/dashboard/products",
  PRODUCT_CREATE: "/dashboard/product/create",
  PRODUCT_EDIT: "/dashboard/product/edit",
  SHOP_EDIT: "/dashboard/shop/edit",
});

export const DASHBOARD_ACTIONS_NAME = Object.freeze({
  // onboarding
  CLICK_TO_BE_SELLER_BUTTON: "CLICK_TO_BE_SELLER_BUTTON",
  INIT_SHOP_COMPLETED: "INIT_SHOP_COMPLETED",
  // editing
  CLICK_CREATE_PRODUCT_BUTTON: "CLICK_CREATE_PRODUCT_BUTTON",
  CLICK_COPY_PRODUCT_BUTTON: "CLICK_COPY_PRODUCT_BUTTON",
  CLICK_DELETE_PRODUCT_BUTTON: "CLICK_DELETE_PRODUCT_BUTTON",
  CLICK_SAVE_PRODUCT_BUTTON: "CLICK_SAVE_PRODUCT_BUTTON",
  CLICK_SAVE_SHOP_BUTTON: "CLICK_SAVE_SHOP_BUTTON",
  CREATE_PRODUCT_SUCCESSFULLY: "CREATE_PRODUCT_SUCCESSFULLY",
  COPY_PRODUCT_SUCCESSFULLY: "COPY_PRODUCT_SUCCESSFULLY",
  DELETE_PRODUCT_SUCCESSFULLY: "DELETE_PRODUCT_SUCCESSFULLY",
  SAVE_PRODUCT_SUCCESSFULLY: "SAVE_PRODUCT_SUCCESSFULLY",
  SAVE_SHOP_SUCCESSFULLY: "SAVE_SHOP_SUCCESSFULLY",
  // activity
  CLICK_EXTERNAL_LINK_SERVICE: "CLICK_EXTERNAL_LINK_SERVICE",
  SHIP_ORDER: "SHIP_ORDER",
});
